import React, { useState } from 'react';

import { Accordion } from '../../../../../ui-kit';
import PaymentSectionFooter from './PaymentSectionFooter';
import '../styles/_payment-section.scss';













function AccordionSection({
  title,
  children,
  footerStartAdornment,
  footerTotalText,
  footerTotalValue,
  hasBottomDivider,
  isOpenedByDefault = true,
  initialOpenIndex,
  ghost
}) {
  const openIndex = isOpenedByDefault ? 0 : -1;
  const [currentOpenedIndex, setCurrentOpenedIndex] = useState(openIndex);
  const getOpenIndex = (index) => setCurrentOpenedIndex(index);
  const isAccordionCollapsed = currentOpenedIndex !== 0;

  return (
    <>
      <Accordion
        titles={[title]}
        initialOpenIndex={isOpenedByDefault ? openIndex : initialOpenIndex}
        getOpenIndex={getOpenIndex}
        shouldPreventSelection={ghost}>

        <div className="payment-section__body">
          {children &&
          <>
              <div className="payment-section__body-content">
                {children}
              </div>

              {hasBottomDivider && <hr className="payment-section__body-divider" />}
            </>}

          <PaymentSectionFooter
            prefixDagger={Boolean(children)}
            footerStartAdornment={footerStartAdornment}
            footerTotalText={footerTotalText}
            footerTotalValue={footerTotalValue} />

        </div>
      </Accordion>
      {isAccordionCollapsed &&
      <PaymentSectionFooter
        prefixDagger={Boolean(children)}
        footerStartAdornment={footerStartAdornment}
        footerTotalText={footerTotalText}
        footerTotalValue={footerTotalValue}
        className="payment-section__footer--collapsed" />}


    </>);

}

export default AccordionSection;